// aggregateByFurniture.js — suskaičiuoja kainą/išklotinę KIEKVIENAM baldo
// vienetui atskirai (grupuojant pagal furnitureId), naudojant tą pačią
// calculatePrice() logiką, kuri jau naudojama vieno aktyvaus baldo
// "Kainų suvestinės" skirtuke.

import { calculatePrice } from './calculatePrice';
import { groupCabinetsByFurniture } from '../utils/groupCabinetsByFurniture';

// sectionOptions raktai yra pavidalo `${furnitureId}-${cabinetIndex}-${sectionPath}`
// (žr. Cabinet3D.jsx getSectionOption) — atrenkame tik konkrečiam baldui priklausančius.
const filterSectionOptionsForFurniture = (sectionOptions, furnitureId) => {
    const prefix = `${furnitureId}-`;
    const out = {};
    Object.entries(sectionOptions || {}).forEach(([key, val]) => {
        if (key.startsWith(prefix)) out[key] = val;
    });
    return out;
};

export const aggregateByFurniture = (allCabinets, settings) => {
    const groups = groupCabinetsByFurniture(allCabinets);
    const { sectionOptions = {}, mergedSections = [] } = settings;

    const perFurniture = groups.map((group) => {
        const scopedSectionOptions = filterSectionOptionsForFurniture(sectionOptions, group.furnitureId);
        const groupSettings = {
            ...settings,
            generalWidth: group.width,
            generalHeight: group.height,
            sectionOptions: scopedSectionOptions,
            mergedSections: mergedSections.filter(s => s.furnitureId === group.furnitureId),
        };
        const calc = calculatePrice(group.cabinets, groupSettings);
        return { ...group, calc, sectionOptions: scopedSectionOptions };
    });

    const grandTotal = perFurniture.reduce((sum, f) => sum + (f.calc?.grandTotal || 0), 0);

    return { perFurniture, grandTotal };
};
